<script setup>
import { $api } from '@/services';
import { defineEmits } from 'vue';

const emit = defineEmits(['close']);

const registerLucaHub = async () => {
	try {
		const res = await $api.org.registerLucaHub();
		if (res) {
			const a = document.createElement('a');
			a.href = res.data.url;
			a.target = '_blank';
			a.rel = 'noopener noreferrer';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			emit('close');
		}
	} catch (e) {
		console.log(e);
	}
};

const openLink = () => {
	window.open('https://www.luca.education/lucahub-partners', '_blank');
	emit('close');
};
</script>
<template>
	<div class="modal-wrapper mt-20 flex items-center justify-center sm-down:mt-10">
		<div class="luca-banner pt-7 sm-down:pt-4">
			<span class="sm-down:text-sm"
				>Tham gia Luca Hub Hoàn toàn miễn phí!</span
			>
		</div>
		<div class="_create-boarding _modal" style="max-width: 802px">
			<div
				class="_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center sm-down:py-4 sm-down:px-4"
			>
				<div class="mt-14 sm-down:mt-6">
					<img
						style="height: 44px"
						src="@/assets/images/illustrations/lucahub.png"
						alt=""
					/>
				</div>
				<div
					class="_modal__content__title text-neutral-700 font-bold text-4xl mt-6 text-center leading-8 sm-down:text-lg sm-down:leading-5"
					style="color: #4f46e5"
				>
					Đưa dịch vụ của bạn đến gần hơn với những
					<br class="sm-down:hidden" />phụ huynh đang thực sự cần
				</div>
				<div
					class="flex items-center justify-between mt-10 sm-down:flex-col sm-down:gap-4"
				>
					<div
						class="flex flex-col items-center justify-center"
						style="width: 206px"
					>
						<div
							class="bg-white rounded-xl flex items-center justify-center s-21 sm-down:w-14 sm-down:h-14"
						>
							<img
								src="@/assets/images/icons/special.png"
								alt=""
								class="object-contain s-15 sm-down:w-8"
							/>
						</div>
						<div
							class="text-neutral-700 font-semibold text-center mt-4 sm-down:text-sm sm-down:font-normal"
						>
							Nền tảng chuyên biệt cho
							<br />Giáo dục đặc biệt
						</div>
					</div>
					<div
						class="flex flex-col items-center justify-center"
						style="width: 206px"
					>
						<div
							class="bg-white rounded-xl flex items-center justify-center s-21 sm-down:w-14 sm-down:h-14"
						>
							<img
								class="object-contain s-15 sm-down:w-8 sm-down:h-8"
								src="@/assets/images/icons/free-tag.png"
								alt=""
							/>
						</div>
						<div
							class="text-neutral-700 font-semibold text-center mt-4 sm-down:text-sm sm-down:font-normal"
						>
							Đăng ký hoàn toàn <br />
							miễn phí
						</div>
					</div>
					<div
						class="flex flex-col items-center justify-center"
						style="width: 206px"
					>
						<div
							class="bg-white rounded-xl flex items-center justify-center s-21 sm-down:w-14 sm-down:h-14"
						>
							<img
								class="object-contain s-15 sm-down:w-8 sm-down:h-8"
								src="@/assets/images/illustrations/shield.png"
								alt=""
							/>
						</div>
						<div
							class="text-neutral-700 font-semibold text-center mt-4 sm-down:text-sm sm-down:font-normal"
						>
							Xác thực uy tín <br />
							trên nền tảng
						</div>
					</div>
				</div>
			</div>
			<div
				class="_modal__footer py-6 px-12 bg-white flex flex-nowrap items-center mt-8 sm-down:mt-4 sm-down:justify-between sm-down:px-4"
			>
				<div
					@click="openLink"
					class="button-p text-center bg-none shadow-none text-neutral-500 hover:text-neutral-700 cursor-pointer"
				>
					Tìm hiểu thêm
				</div>
				<button
					type="button"
					style="height: 64px"
					class="button-p text-center whitespace-nowrap p-5 sm-down:hidden"
					@click="registerLucaHub"
				>
					Tham gia ngay hôm nay!
				</button>
				<button
					type="button"
					style="height: 64px"
					class="button-p text-center whitespace-nowrap p-5 sm-down:block hidden"
					@click="registerLucaHub"
				>
					Tham gia ngay!
				</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
.modal-wrapper {
	position: relative;
}

._create-boarding {
	position: relative;
	z-index: 1;
	background: url('../../assets/images/background/linear.png') no-repeat
		center center;
	background-size: cover;
}
.luca-banner {
	width: 90%;
	height: 152px;
	background: linear-gradient(90deg, #5a5de8, #8f90f5);
	color: #fff;
	display: flex;
	justify-content: center;
	font-weight: 600;
	font-size: 23px;
	border-radius: 16px 16px 0 0;
	position: absolute;
	top: -92px;
}
.s-21 {
	width: 84px;
	height: 84px;
}
.s-15 {
	width: 60px;
	height: 60px;
}
@media screen and (max-width: 480px) {
	._create-boarding {
		background: url('../../assets/images/background/linear-phone.png')
			no-repeat center center;
		background-size: cover;
	}
	.luca-banner {
		top: -60px;
	}
}
</style>